import { SerializedIncidentBarChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { useIncidentStore } from '@/store/incident'
import { IncidentChartResultPipeline } from '@/composables/charts/IncidentChartResultPipeline'
import { AbstractDatabaseEntryChartBuilder } from '@/composables/charts/influx-charts/chart-builders/AbstractDatabaseEntryChartBuilder'
import { DocumentQuerySelect } from '@/types/Query'

export class IncidentBarChartBuilder extends AbstractDatabaseEntryChartBuilder {
  private readonly incidentTypes: string[]
  private readonly timestampMode: 'opened' | 'closed' = 'opened'

  constructor(serialized: SerializedIncidentBarChart) {
    super(serialized)
    this.incidentTypes = serialized.incidentTypes
    this.timestampMode = serialized.timestampMode
  }

  serialize(): SerializedIncidentBarChart {
    return {
      ...super.serialize(),
      chartType: CHART_TYPES.INCIDENT_BAR,
      incidentTypes: this.incidentTypes,
      timestampMode: this.timestampMode,
    }
  }

  autoInferChartEntity(): string | undefined {
    return 'frontend-charts.incidents'
  }

  protected async loadData() {
    const compiled = this.timeSetup.compile()
    const additionalFilters: DocumentQuerySelect[] = []
    if (this.additionalFilters) additionalFilters.push(...this.additionalFilters)
    if (this.transientAdditionalFilters) additionalFilters.push(...this.transientAdditionalFilters)
    const incidents = await useIncidentStore().loadIncidentsOpenBetweenSpecificTimestamps(
      this.incidentTypes,
      compiled.start,
      compiled.end,
      undefined,
      { firstEventTimestamp: 'asc' },
      additionalFilters,
      undefined
    )
    if (incidents) {
      const resultPipeline = new IncidentChartResultPipeline()
      this.series = await resultPipeline.prepareData(incidents, this.timestampMode, this.groupByDimensions, compiled)
      this.buildOptions()
    }
  }
}
